<div class="row m-0 pt-5">
	<div class="col-lg-12">
		<div class="titolo text-center pt-5">Contact us</div>
		<div class="row d-flex justify-content-center">
			<div class="col-12 col-md-6">
				<div class="data-field mb-2">
					<span *ngIf="userData && userData.name">{{ userData.name }}</span>
					<span *ngIf="!userData || !userData.name" class="placeholder">{{ "USER.NAME" | translate }}</span>
				</div>
				<div class="data-field mb-2">
					<span *ngIf="userData && userData.surname">{{ userData.surname }}</span>
					<span *ngIf="!userData || !userData.surname" class="placeholder">
						{{ "USER.SURNAME" | translate }}
					</span>
				</div>
				<div class="data-field mb-2">
					<span *ngIf="userData && userData.email">{{ userData.email }}</span>
					<span *ngIf="!userData || !userData.email" class="placeholder">{{ "USER.EMAIL" | translate }}</span>
				</div>
				<div class="data-field mb-2">
					<span *ngIf="userData && userData.company">{{ userData.company }}</span>
					<span *ngIf="!userData || !userData.company" class="placeholder">
						{{ "USER.COMPANY" | translate }}
					</span>
				</div>
				<div class="data-field mb-2">
					<span *ngIf="userData && userData.country">{{ userData.country }}</span>
					<span *ngIf="!userData || !userData.country" class="placeholder">
						{{ "USER.COUNTRY" | translate }}
					</span>
				</div>
			</div>
			<form [formGroup]="contactForm" class="col-12 col-md-6 d-flex justify-content-center align-items-center">
				<div class="align-self-start w-100">
					<mat-form-field appearance="outline" class="w-100">
						<textarea
							class="textarea"
							matInput
							[(ngModel)]="message"
							formControlName="message"
							placeholder="Message"
							name="Message"
							required
						></textarea>
					</mat-form-field>
				</div>
			</form>
		</div>
		<div class="w-100 d-flex justify-content-center">
			<div class="flex-column align-items-center">
				<button
					mat-stroked-button
					[disabled]="disabled"
					class="btn pt-2 pb-2 rounded-0 mt-3 d-block"
					(click)="onSubmit()"
				>
					<mat-spinner *ngIf="waitLogin"></mat-spinner>
					<span *ngIf="!waitLogin">{{ "GENERAL.SEND_MESSAGE" | translate }}</span>
				</button>
			</div>
		</div>
	</div>
</div>
